import { html, css, LitElement } from "lit";
import { property, state, customElement } from "lit/decorators.js";
import "@justifi/webcomponents/dist/webcomponents/webcomponents.esm.js";
import { parseJwt, apiHost } from "../lib/utils.js";
import "./loading-animation.js";
import { when } from "lit/directives/when.js";
import { classMap } from "lit/directives/class-map.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
const paymentProcessorClientId = {
  live: "live_qrutPmwY10YbjFInxwPh6GQgGagneeDq",
  test: "test_hh3GX6nxz0NHWI8xQRoAcFo8xDIM9qZP"
};
function cardSvg(cardBrand) {
  switch (cardBrand) {
    case "visa":
      return visa;
    case "mastercard":
      return mastercard;
    case "amex":
      return amex;
    default:
      return defaultCard;
  }
}
const mastercard = html`
  <svg
    class="card-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
  >
    <path
      d="M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
    />
  </svg>
`;
const amex = html`
  <svg
    class="card-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
  >
    <path
      d="M48 480C21.49 480 0 458.5 0 432V80C0 53.49 21.49 32 48 32H528C554.5 32 576 53.49 576 80V82.43H500.5L483.5 130L466.6 82.43H369.4V145.6L341.3 82.43H262.7L181 267.1H246.8V430.9H450.5L482.4 395.8L514.3 430.9H576V432C576 458.5 554.5 480 528 480H48zM482.6 364L440.4 410.3H390.5L458 338.6L390.5 266.1H441.9L483.4 312.8L525.4 266.1H576L508 338.2L576 410.3H524.6L482.6 364zM576 296.9V380.2L536.7 338.3L576 296.9zM307.6 377.1H390.6V410.3H268.6V267.1H390.6V300.2H307.6V322.6H388.5V354.9H307.6V377.2V377.1zM537.3 145.7L500.4 246.3H466L429.2 146V246.3H390.5V103H451.7L483.6 192.3L515.8 103H576V246.3H537.3V145.7zM334.5 217.6H268.6L256.7 246.3H213.7L276.1 103H327.3L390.6 246.3H346.5L334.5 217.6zM301.5 138.5L282 185.4H320.9L301.5 138.5z"
    />
  </svg>
`;
const visa = html`
  <svg 
    class="card-icon 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 576 512"
  >
    <path
      d="M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
    />
  </svg>
`;
const defaultCard = html`
  <svg
    class="card-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
  >
    <path
      d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    />
  </svg>
`;
let PaymentElement = class extends LitElement {
  constructor() {
    super(...arguments);
    this.loading = true;
    this.loadingCardElement = true;
    this.displayExistingPaymentMethod = false;
  }
  async connectedCallback() {
    var _a;
    super.connectedCallback();
    (_a = this.shadowRoot) == null ? void 0 : _a.addEventListener("ready", () => {
      this.loadingCardElement = false;
    });
    await this.loadPaymentMethods();
  }
  async loadPaymentMethods() {
    this.loading = true;
    if (this.customerClientSecret === void 0) {
      this.displayExistingPaymentMethod = false;
      this.loading = false;
      return;
    }
    const customerId = parseJwt(this.customerClientSecret).customer_id;
    const res = await fetch(`${apiHost}/v1/customers/${customerId}/payment-method`, {
      headers: {
        "Authorization": `Bearer ${this.customerClientSecret}`
      }
    });
    this.loading = false;
    if (res.status == 200) {
      const jsonData = await res.json();
      this.paymentMethod = jsonData.card;
      this.displayExistingPaymentMethod = true;
      this.loadingCardElement = false;
    } else {
      this.displayExistingPaymentMethod = false;
    }
  }
  async validate() {
    var _a;
    const errors = [];
    const cardForm = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("justifi-card-form");
    const res = await (cardForm == null ? void 0 : cardForm.validate());
    const isFormValid = res ? res.isValid : false;
    if (!isFormValid) {
      errors.push("invalid_card_data");
    }
    const response = {
      isValid: isFormValid,
      errors
    };
    return response;
  }
  async tokenize(paymentMethodData) {
    var _a;
    if (this.displayExistingPaymentMethod && this.paymentMethod) {
      return new Promise((resolve) => resolve(this.paymentMethod.token));
    }
    const isValid = (await this.validate()).isValid;
    if (!isValid) {
      throw new Error("Tokenization failed due to validation errors.");
    }
    if (!paymentMethodData.address_postal_code || paymentMethodData.address_postal_code === "") {
      throw new Error("Tokenization failed due to missing billing zip code.");
    }
    const requestClientId = this.clientId.startsWith("test") ? paymentProcessorClientId.test : paymentProcessorClientId.live;
    const cardForm = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("justifi-card-form");
    const res = await (cardForm == null ? void 0 : cardForm.tokenize(requestClientId, paymentMethodData));
    return res == null ? void 0 : res.id;
  }
  render() {
    return html`
      <div id="payment-element-wrapper" class=${classMap({ "expand-for-iframe": !this.displayExistingPaymentMethod })}>
        ${when(this.loading || this.loadingCardElement, () => html`
          <loading-animation></loading-animation>
        `)}
        ${when(this.displayExistingPaymentMethod, () => html`
          <section id="currently-saved-card">
            <div>${cardSvg(this.paymentMethod.brand)}</div>
            <div id="card-number" class="${this.paymentMethod.brand}">
              ${this.paymentMethod.acct_last_four}
            </div>
            <div>
              ${this.paymentMethod.month}/${this.paymentMethod.year}
            </div>
            <button
              id="edit-payment-card"
              @click=${() => this.displayExistingPaymentMethod = false}
            >
              edit
            </button>
          </section>
        `, () => html`
          <section id="payment-form" style=${!this.loading && !this.displayExistingPaymentMethod ? "display: block;" : "display: none;"}>
            <!-- <section id="billing-info">
              <div class="form-control">
                <label for="card-holder-name">Card Holder Name</label>
                <input type="text" id="card-holder-name" name="card_holder_name" placeholder="Full Name"/>
              </div>
              <div class="form-control">
                <label for="billing-zip">Billing ZIP Code</label>
                <input type="text" id="billing-zip" name="billing_zip" placeholder="Billing ZIP"/>
              </div>
            </section> -->
            <justifi-card-form></justifi-card-form>
          </section>
          
        `)}
      </div>
    `;
  }
};
PaymentElement.styles = css`

    #payment-element-wrapper {
      display: flex;
      flex: 1;
      justify-content: center;
      width: 100%;
      position: relative;
      min-height: 40px;
      margin-bottom: 10px;
      margin-top: 10px;
    }

    .expand-for-iframe {
      min-height: 140px !important;
    }

    #currently-saved-card {
      display: flex;
      gap: 15px;
  
      justify-content: center;
      align-items: center;
  
      padding: 6px 10px;
      margin-bottom: 10px;
      border: 1px solid var(--default-vi-border-color);
      border-radius: var(--default-vi-border-radius);
    }

    #currently-saved-card div {
      display: flex;
      align-items: center;
    }
  
    .card-icon {
      width: 30px;
    }
  
    #card-number {
      font-weight: bold;
    }
  
    .mastercard,
    .visa:before {
      content: "**** **** **** ";
    }
  
    .amex:before {
      content: "**** ****** *";
    }
  
    button {
      color: var(--default-vi-primary-color);
      text-decoration: underline;
      font-size: 0.9rem;
      background: none;
      border: none;
      cursor: pointer;
    }
  
    button:hover {
      text-decoration: none;
    }

    loading-animation {
      position: absolute;
      inset: 0;
    }

    justifi-card-form {
      width: 100%;
    }

    section#billing-info {
      display: flex;
      width: 100%;
      gap: 1rem;
      margin-bottom: 1rem;
    }

    section#billing-info .form-control {
      flex: 1;
      display: flex;
    flex-direction: column;
    }
    
    section#payment-form {
      width: 100%;
    }

    @media (max-width: 700px) {
      section#payment-form {
        flex-direction: column;
      }
    }

    @container (max-width: 700px) {
      section#payment-form {
        flex-direction: column;
      }
    }

    label {
      color: var(--jfi-form-label-color);
      display: block;
      font-size: var(--jfi-form-label-font-size);
      margin: var(--jfi-form-label-margin);
      
    }

    input { 
      border-width: 0px;
      background: transparent;
      font-size: var(--jfi-form-control-font-size);
      padding: 0;
      line-height: var(--jfi-form-control-line-height);
      box-shadow: var(--jfi-form-control-box-shadow);
      border-color: var(--jfi-form-control-border-color);
      border-width: var(--jfi-form-control-border-width);
      border-radius: var(--jfi-form-control-border-radius);
      border-style: solid;
      padding: var(--jfi-form-control-padding);
    }

    input:focus-visible, input:focus {
      outline: none;
      border-color: var(--jfi-form-control-border-color-focus);
    }

    input.error {
      border-color: var(--jfi-form-control-border-color-error);
    }
  `;
__decorateClass([
  property()
], PaymentElement.prototype, "customerClientSecret", 2);
__decorateClass([
  property()
], PaymentElement.prototype, "clientId", 2);
__decorateClass([
  state()
], PaymentElement.prototype, "loading", 2);
__decorateClass([
  state()
], PaymentElement.prototype, "loadingCardElement", 2);
__decorateClass([
  state()
], PaymentElement.prototype, "displayExistingPaymentMethod", 2);
__decorateClass([
  state()
], PaymentElement.prototype, "paymentMethod", 2);
PaymentElement = __decorateClass([
  customElement("payment-element")
], PaymentElement);
export {
  PaymentElement,
  cardSvg
};
